
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartCatzocIec as ObiChartCatzocIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-catzoc-iec.js';
 
 
 

 
 export const ObiChartCatzocIec = createComponent({
   react: React,
   tagName: 'obi-chart-catzoc-iec',
   elementClass: ObiChartCatzocIecElement,
   events: {
     
   }
  });
 
 